import baseUrl from "../Api/baseUrl";
const GetData = async (url, params) => {
  const res = await baseUrl.get(url);
  return res.data;
};
const GetDataToken = async (url, parmas) => {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("tokenhr")}` },
  };
  const res = await baseUrl.get(url, config);
  return res.data;
};

const GetDataTokenWithheader = async (url, parmas) => {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("tokenhr")}` },
  };
  const res = await baseUrl.get(url, config);
  return res;
};

export { GetData, GetDataToken, GetDataTokenWithheader };
